import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('gjs-socket-alert', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'socket-alert',
    blocks: ['socket-alert'],
    defaultStyle: true,
    labelTable: 'Socket Alert',
    labelSocketAlertCategory: 'Advanced',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
